import { getExtensions } from '@atlassian/relay-capture-extensions';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import SearchResultsQuery from '../../../ui/search-page-relay/search-results/__generated__/searchResultsQuery.graphql';

import { getQueryUpdatedTime } from './query-updated-time';

export type ExtensionData = {
	traceId: string | undefined;
	queryUpdatedAgo: number | undefined;
};

export function getExtensionData(): ExtensionData {
	const extensions = getExtensions(SearchResultsQuery.operation.name)?.at(-1) as
		| Record<string, any>
		| undefined;
	const gateway = extensions?.gateway;
	// Using request_id and falling back to trace_id
	// The only difference is that request_id is a valid UUID string, while traceId is without dashes
	const traceId = gateway?.['request_id'] || gateway?.['trace_id'];
	const queryUpdatedAgo = getQueryUpdatedTime();
	return { traceId, queryUpdatedAgo };
}
